import NextPrevSubmitButton from './next-prev-submit-buttons'

export default NextPrevSubmitButton
